import { Table } from 'antd';
import React from 'react';

import { COLUMNS } from '@app/pages/Analytics/ActualImplementation/data';
import type { ActualImplementationTableProps } from '@app/pages/Analytics/ActualImplementation/types';
import { transformActualImplementationToTableData } from '@app/pages/Analytics/ActualImplementation/utils';

const HEADER_HEIGHT = 320;

export const ActualImplementationTable: React.FC<
  ActualImplementationTableProps
> = ({ isLoading, tableData }) => {
  return (
    <Table
      bordered
      columns={COLUMNS}
      dataSource={transformActualImplementationToTableData(tableData)}
      pagination={false}
      loading={isLoading}
      className="table-border-dark"
      scroll={{ x: 'max-content', y: `calc(100vh - ${HEADER_HEIGHT}px)` }}
    />
  );
};
